export default {
    state: {
        prod:{},  // 用户信息
    },
  
    mutations: {
      // 设置用户信息
      SET_PROD(state, data) {
        state.prod = data
      }
  
    },
  
    actions: {
      // 设置用户信息
      setProd(context, data) {
        context.commit('SET_PROD', data)
      },
    }
  }